import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import {
  Navigate,
  useLocation,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { Box } from "@mui/material";

import "../src/style/style.css";

import Biometric from "./components/auth/Biometric";
import Createpin from "./components/auth/Createpin";
import ForgotPassword from "./components/auth/ForgotPassword";
import Login from "./components/auth/Login";
import Loginwithpin from "./components/auth/Loginwithpin";
import Otp from "./components/auth/Otp";
import Reset from "./components/auth/Reset";
import Signup from "./components/auth/Signup";
import Terms from "./components/auth/Terms";
import Uploadimage from "./components/auth/Uploadimage";
import EConsent from "./components/auth/EConsent";
import DownloadApp from "./components/auth/DownloadApp";

import MainDashboard from "./components/common/Layout/MainDashboard";
import LeftSide from "./components/common/Layout/LeftSide";
import PremiumPopupHandler from "./components/common/Popups/PremiumPopupHandler";

import PrivateRoute from "./config/PrivateRoute";
import PublicRoute from "./config/PublicRoute";

import store from "./Redux/store";
import { fetchUserCurrency } from "./Redux/currencySlice";

import { getUserFromLocalStorage } from "./utils/utils";
import { PopupProvider } from "./context/PopupContext";
import { useAppDispatch } from "./Redux/hooks";
// import PhoneVerifyPage from "./components/common/MainComponents/PhoneVerifyPage";

function AppContent() {
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const INACTIVITY_DURATION_MS = 15 * 60 * 1000;

  const AuthRoutes = [
    "/signup",
    "/login",
    "/forgot",
    "/otp",
    "/createpin",
    "/reset",
    "/terms",
    "/biometric",
    "/uploadimage",
    "/loginwithpin",
    "/e-consent",
    // "/phone-verification",
  ];

  const isAuth2 = AuthRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  const isMobile = window.innerWidth <= 768;

  // Fetch currency once
  useEffect(() => {
    const user = getUserFromLocalStorage();
    if (user?.isVerify) {
      dispatch(fetchUserCurrency());
    }
  }, [dispatch]);

  React.useEffect(() => {
    const pinVerified = sessionStorage.getItem("pinVerified");
    const user = getUserFromLocalStorage();

    if (!user) return;
    // if (!user?.isPhoneVerify) {
    //   navigation("/phone-verification", { state: { user } });
    // } else
    if (!user?.isVerify) {
      navigation("/otp");
    } else if (
      (pinVerified === undefined || pinVerified === null) &&
      user?.IsPINCreated
    ) {
      navigation("/loginwithpin");
    } else if (user?.acceptDisclosure === false) {
      navigation("/terms", { state: user });
    } else if (user?.IsPINCreated === false) {
      navigation("/createpin");
    }
  }, [navigation]);

  // Inactivity handler
  React.useEffect(() => {
    let inactivityTimeoutId = null;

    const clearExistingTimeout = () => {
      if (inactivityTimeoutId) {
        clearTimeout(inactivityTimeoutId);
        inactivityTimeoutId = null;
      }
    };

    const handleTimeout = () => {
      const user = getUserFromLocalStorage();

      if (user && sessionStorage.getItem("pinVerified") === "true") {
        sessionStorage.removeItem("pinVerified");

        navigation(
          user.IsPINCreated ? "/loginwithpin" : "/createpin"
        );
      }
    };

    const resetInactivityTimer = () => {
      clearExistingTimeout();

      if (sessionStorage.getItem("pinVerified") === "true") {
        inactivityTimeoutId = setTimeout(
          handleTimeout,
          INACTIVITY_DURATION_MS
        );
      }
    };

    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "wheel",
      "pointerdown",
    ];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetInactivityTimer, {
        passive: true,
      });
    });

    resetInactivityTimer();

    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetInactivityTimer);
      });

      clearExistingTimeout();
    };
  }, [location.pathname, navigation]);

  if (isMobile) {
    return <DownloadApp />;
  }

  return (
    <PopupProvider>
      <Box display="flex" bgcolor={isAuth2 ? "#000000" : ""} width="100%" height="fit-content">
        {isAuth2 && (
          <Box
            width="50%"
            display="flex"
            alignItems="center"
            sx={{
              minHeight: "100vh",
              "@media (max-width: 1023px)": {
                display: "none",
              },
            }}
          >
            <LeftSide />
          </Box>
        )}

        <Box
          width={isAuth2 ? "50%" : "100%"}
          sx={{
            "@media (max-width: 1023px)": {
              width: "100%",
            },
          }}
        >
          <Routes>
            <Route path="/signup" element={<PublicRoute element={Signup} />} />
            <Route path="/login" element={<PublicRoute element={Login} />} />
            <Route
              path="/forgot"
              element={<PublicRoute element={ForgotPassword} />}
            />
            {/* <Route path="/phone-verification" element={<PhoneVerifyPage />} /> */}
            <Route path="/otp" element={<Otp />} />
            <Route path="/createpin" element={<Createpin />} />
            <Route path="/reset" element={<PublicRoute element={Reset} />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/e-consent" element={<EConsent />} />
            <Route
              path="/biometric"
              element={<PublicRoute element={Biometric} />}
            />
            <Route
              path="/uploadimage"
              element={<PrivateRoute element={Uploadimage} />}
            />
            <Route
              path="/loginwithpin"
              element={<PrivateRoute element={Loginwithpin} />}
            />
            <Route
              path="/*"
              element={<PrivateRoute element={MainDashboard} />}
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Box>
      </Box>
      <PremiumPopupHandler />
    </PopupProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;